/* eslint-disable max-lines */
import React from 'react';
import styled from 'styled-components/macro';
import {
  RobotIcon,
  CustomValidationIcon,
  ClaimValidationIcon,
  ReportIcon,
  ContractAbstractionIcon,
  RXValidationIcon,
  InvoiceWorkFlowIcon,
  ConfiguratorIcon,
  ControlTowerIcon,
  ArchiveIcon,
  MLDashboardIcon,
  DispatcherIcon,
  AcquisitionMonitor,
  Archive as ArchiveSidebar,
  InvoiceManagement,
  Upload,
  Search,
} from 'images/icons-lucy4/sidebar-icons';
import AcquisitionIconLucy from 'images/icons-lucy4/acquisition';
import AddressBookIcon from 'images/icons-lucy4/addressBook';
import AddressCardIcon from 'images/icons-lucy4/addressCard';
import AiIconLucy from 'images/icons-lucy4/ai';
import AngleUpIcon from 'images/icons-lucy4/angle-up';
import ArchiveIconLucy from 'images/icons-lucy4/archive';
import ArrowAltVIcon from 'images/icons-lucy4/arrow-alt-v';
import ArrowIcon from 'images/icons-lucy4/arrow';
import AssignedIcon from 'images/icons-lucy4/assigned';
import BlockCircleIconLucy from 'images/icons-lucy4/block-circle';
import ChevronIconLucy from 'images/icons-lucy4/chevron';
import CircleOutlineIcon from 'images/icons-lucy4/circle-outline';
import CircleIconLucy from 'images/icons-lucy4/circle';
import CircleCheckIcon from 'images/icons-lucy4/circleCheck';
import CloudUploadAltIcon from 'images/icons-lucy4/cloud-upload-alt';
import CogIcon from 'images/icons-lucy4/cog';
import DoubleChevronIcon from 'images/icons-lucy4/doubleChevron';
import DownloadIcon from 'images/icons-lucy4/download';
import DuplicatedIconLucy from 'images/icons-lucy4/duplicated';
import EnvelopeIcon from 'images/icons-lucy4/envelope';
import EqualIcon from 'images/icons-lucy4/equal';
import ExlamationCircleIcon from 'images/icons-lucy4/exlamationCircle';
import EyeSlashIcon from 'images/icons-lucy4/eye-slash';
import EyeIconLucy from 'images/icons-lucy4/eye';
import FaCheckIcon from 'images/icons-lucy4/faCheck';
import FilePdfIcon from 'images/icons-lucy4/file-pdf';
import FileCsvIcon from 'images/icons-lucy4/fileCsv';
import FileDownloadIcon from 'images/icons-lucy4/fileDownload';
import FolderIcon from 'images/icons-lucy4/folder';
import GlobeIcon from 'images/icons-lucy4/globe';
import GridIcon from 'images/icons-lucy4/grid';
import KeyboardIcon from 'images/icons-lucy4/keyboard';
import MinusIcon from 'images/icons-lucy4/minus';
import ObjectUngroupIcon from 'images/icons-lucy4/object-ungroup';
import PaperclipIcon from 'images/icons-lucy4/paperclip';
import PlusIcon from 'images/icons-lucy4/plus';
import PrintIcon from 'images/icons-lucy4/print';
import QuestionMarkIconLucy from 'images/icons-lucy4/question-mark';
import RedoAltIcon from 'images/icons-lucy4/redo-alt';
import SearchPlusIcon from 'images/icons-lucy4/search-plus';
import SquareIcon from 'images/icons-lucy4/square';
import TableNotVerifiedIconLucy from 'images/icons-lucy4/tableNotVerified';
import TableVerifiedIconLucy from 'images/icons-lucy4/tableVerified';
import TimesIcon from 'images/icons-lucy4/times';
import TooltipIcon from 'images/icons-lucy4/Tooltip';
import TopPageIconLucy from 'images/icons-lucy4/topPage';
import TrashIcon from 'images/icons-lucy4/trash';
import TriangleIcon from 'images/icons-lucy4/triangle';
import WorkflowIconLucy from 'images/icons-lucy4/workflow';
import CloudUp from 'images/icons-lucy4/cloud-upload-alt';
import SearchMinus from 'images/icons-lucy4/searchMinus';
import AlreadyAssigned from 'images/icons-lucy4/alreadyAssigned';
import Paragraph from 'images/icons-lucy4/paragraph';
import Warning from 'images/icons-lucy4/warning';
import { useTheme } from 'providers/ThemeProvider';
import Validation from 'images/icons-lucy4/validation';
import CheckFilled from 'images/icons-lucy4/checkedFilled';
import TooltipFilled from 'images/icons-lucy4/tooltipFilled';
import ExportIcon from 'images/icons-lucy4/exportIcon';
import LayerGroup from 'images/icons-lucy4/layerGroup';
import StickyNote from 'images/icons-lucy4/stickyNote';
import Copy from 'images/icons-lucy4/copy';
import Paste from 'images/icons-lucy4/paste';
import Ocr from 'images/icons-lucy4/ocr';
import OcrArea from 'images/icons-lucy4/ocr-area';
import OcrPointer from 'images/icons-lucy4/ocr-pointer';
import ArrowUpCircle from 'images/icons-lucy4/arrow-up-circle';
import File from 'images/icons-lucy4/file';
import Check from 'images/icons-lucy4/check';
import Th from 'images/icons-lucy4/th';
import ExchangeAlt from 'images/icons-lucy4/exchange-alt';
import Decrease from 'images/icons-lucy4/decrease';
import Increase from 'images/icons-lucy4/increase';
import Stable from 'images/icons-lucy4/stable';
import Floppy from 'images/icons-lucy4/floppy';
import Cycle from 'images/icons-lucy4/cycle';
import GetNotAutomated from 'images/icons-lucy4/get-non-automated';
import Rebatch from 'images/icons-lucy4/Rebatch';
import Folder from 'images/icons-lucy4/folder2';
import ChangeClaimMessage from 'images/icons-lucy4/change-claim-message';
import DownloadImport from 'images/icons-lucy4/download-import';
import Add from 'images/icons-lucy4/add';
import Pen from 'images/icons-lucy4/pen';
import Pause from 'images/icons-lucy4/pause';
import CircleQuestionMark from 'images/icons-lucy4/circle-questionMark';
import Locker from 'images/icons-lucy4/locker';
import RevertFlux from 'images/icons-lucy4/revert-flux';
import BlockNotes from 'images/icons-lucy4/block-notes';
import ThreeDArrow from 'images/icons-lucy4/3d-arrow';
import CycleSquareFlux from 'images/icons-lucy4/cycle-square-flux';
import SearchVoid from 'images/icons-lucy4/search-void';
import SearchX from 'images/icons-lucy4/search-x';
import CycleCircleFlux from 'images/icons-lucy4/cycle-circle-flux';
import RadioBack from 'images/icons-lucy4/radio-back';
import RadioPause from 'images/icons-lucy4/radio-pause';
import RadioPlay from 'images/icons-lucy4/radio-play';
import DoubleCheck from 'images/icons-lucy4/double-check';
import UserPlus from 'images/icons-lucy4/user-plus';
import SquarePlus from 'images/icons-lucy4/square-plus';
import PenSquares from 'images/icons-lucy4/pen-squares';
import Ladder from 'images/icons-lucy4/ladder';
import AttentionSignal from 'images/icons-lucy4/attention-signal';
import Clear from 'images/clear.svg';
import Dock from 'images/dock.svg';
import CalendarAlt from 'images/icons-lucy4/calendarAlt';
import Calendar from 'images/icons-lucy4/calendar';
import SquareLink from 'images/icons-lucy4/square-link';
import SplitFixIcon from 'images/icons-lucy4/splitFix';
import ConnectIcon from 'images/icons-lucy4/connect';
import DisconnectIcon from 'images/icons-lucy4/disconnect';
import IsConnectingcon from 'images/icons-lucy4/isConnecting';
import LogIcon from 'images/icons-lucy4/log';
import AskInfoIcon from 'images/icons-lucy4/askInfo';
import Save from 'images/icons-lucy4/save';
import ExportColoredIcon from 'images/icons-lucy4/exportColored';
import DowloadWithArrowIcon from 'images/icons-lucy4/dowloadWithArrow';
import UploadWithArrowIcon from 'images/icons-lucy4/uploadWithArrow';
import TimerIcon from 'images/icons-lucy4/timer';
import RejectIcon from 'images/icons-lucy4/reject';
import PreviousIcon from 'images/icons-lucy4/previous';
import ParkIcon from 'images/icons-lucy4/park';
import TableIcon from 'images/icons-lucy4/table';
import LayoutIcon from 'images/icons-lucy4/layout';
import HotkeysIcon from 'images/icons-lucy4/hotkeys';
import WriteIcon from 'images/icons-lucy4/write';
import RedAlert from 'images/icons-lucy4/red-alert';
import LessCritical from 'images/icons-lucy4/less-critical';
import GreenCheck from 'images/icons-lucy4/green-check';
import Expired from 'images/icons-lucy4/expired';
import Critical from 'images/icons-lucy4/critical';

const IconContainer = styled.div<{ disabled: boolean; cursor?: string }>`
  color: ${({ disabled, theme }) =>
    disabled ? `${theme.colorPalette.turquoise.accent}` : `${theme.colorPalette.grey.grey5}`};
  cursor: ${({ disabled, cursor }) => (cursor ? cursor : disabled ? 'cursor' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const iconMap = {
  clear: Clear,
  dock: Dock,
  robot: <RobotIcon />,
  'custom-validation': <CustomValidationIcon />,
  'claim-validation': <ClaimValidationIcon />,
  report: <ReportIcon />,
  'contract-abstraction': <ContractAbstractionIcon />,
  'rx-validation': <RXValidationIcon />,
  'invoice-workflow': <InvoiceWorkFlowIcon />,
  configurator: <ConfiguratorIcon />,
  'control-tower': <ControlTowerIcon />,
  'archive-icon': <ArchiveIcon />,
  'ml-dashboard': <MLDashboardIcon />,
  dispatcher: <DispatcherIcon />,
  'acquisition-monitor': <AcquisitionMonitor />,
  archiveSidebar: <ArchiveSidebar />,
  'invoice-management': <InvoiceManagement />,
  upload: <Upload />,
  search: <Search />,
  validation: <Validation />,
  acquisition: <AcquisitionIconLucy />,
  'table-verified': <TableVerifiedIconLucy />,
  'table-not-verified': <TableNotVerifiedIconLucy />,
  paragraph: <Paragraph />,
  'paragraph-confirmed': <Paragraph />,
  'check-filled': <CheckFilled />,
  'tooltip-filled': <TooltipFilled />,
  exportToSapColored: <ExportColoredIcon />,
  export: <ExportIcon />,
  'export-disabled': <ExportIcon></ExportIcon>,
  arrow: <ArrowIcon />,
  'arrow-up': <ArrowIcon />,
  'arrow-down': <ArrowIcon />,
  'arrow-alt-v': <ArrowAltVIcon />,
  ai: <AiIconLucy />,
  chevron: <ChevronIconLucy />,
  'duplicated-icon': <DuplicatedIconLucy />,
  'top-page': <TopPageIconLucy />,
  'address-book': <AddressBookIcon />,
  'address-card': <AddressCardIcon />,
  'angle-up': <AngleUpIcon />,
  'priority-high': <AngleUpIcon />,
  'priority-low': <AngleUpIcon />,
  assigned: <AssignedIcon />,
  'block-circle': <BlockCircleIconLucy />,
  calendar: <Calendar />,
  'circle-outline': <CircleOutlineIcon />,
  circle: <CircleIconLucy />,
  'yellow-circle': <CircleIconLucy />,
  'green-circle': <CircleIconLucy />,
  'red-circle': <CircleIconLucy />,
  'circle-check': <CircleCheckIcon />,
  'cloud-upload-alt': <CloudUploadAltIcon />,
  cog: <CogIcon />,
  'double-chevron': <DoubleChevronIcon />,
  'critical-priority': <DoubleChevronIcon />,
  download: <DownloadIcon />,
  envelope: <EnvelopeIcon />,
  equal: <EqualIcon />,
  'priority-medium': <EqualIcon />,
  'exclamation-circle-lucy': <ExlamationCircleIcon />,
  'eye-slash': <EyeSlashIcon />,
  eye: <EyeIconLucy />,
  'fa-check': <FaCheckIcon />,
  'file-pdf': <FilePdfIcon />,
  'file-csv': <FileCsvIcon />,
  'file-download': <FileDownloadIcon />,
  folder: <FolderIcon />,
  globe: <GlobeIcon />,
  grid: <GridIcon />,
  keyboard: <KeyboardIcon />,
  lessCritical: <LessCritical />,
  minus: <MinusIcon />,
  searchMinus: <SearchMinus />,
  'question-mark': <QuestionMarkIconLucy />,
  print: <PrintIcon />,
  'object-ungroup': <ObjectUngroupIcon />,
  paperclip: <PaperclipIcon />,
  plus: <PlusIcon />,
  'redo-alt': <RedoAltIcon />,
  'red-alert': <RedAlert />,
  'less-critical': <LessCritical />,
  'green-check': <GreenCheck />,
  critical: <Critical />,
  expired: <Expired />,
  'undo-alt': <RedoAltIcon />,
  'search-plus': <SearchPlusIcon />,
  square: <SquareIcon />,
  'yellow-square': <SquareIcon />,
  times: <TimesIcon />,
  tooltip: <TooltipIcon />,
  triangle: <TriangleIcon />,
  'red-triangle': <TriangleIcon />,
  trash: <TrashIcon />,
  workflow: <WorkflowIconLucy />,
  CloudUp: <CloudUp />,
  alreadyAssigned: <AlreadyAssigned />,
  'already-assigned': <AlreadyAssigned />,
  warning: <Warning />,
  archive: <ArchiveIconLucy />,
  'border-all': <TableVerifiedIconLucy />,
  'exclamation-circle': <CheckFilled />,
  'paragraph-field': <Paragraph />,
  ocr: <Ocr />,
  'ocr-area': <OcrArea />,
  'ocr-click': <OcrPointer />,
  copy: <Copy />,
  check: <Check />,
  th: <Th />,
  'sticky-note': <StickyNote />,
  'calendar-alt': <CalendarAlt />,
  'info-circle': <TooltipFilled />,
  'exclamation-mark': <ExlamationCircleIcon />,
  'angle-left': <AngleUpIcon />,
  'angle-down': <AngleUpIcon />,
  info: <ExlamationCircleIcon />,
  'layer-group': <LayerGroup />,
  'upload-file': <Upload />,
  paste: <Paste />,
  'arrow-up-circle': <ArrowUpCircle />,
  'arrow-down-circle': <ArrowUpCircle />,
  file: <File />,
  'exchange-alt': <ExchangeAlt />,
  'trend-down': <Decrease />,
  'trend-up': <Increase />,
  'trend-stable': <Stable />,
  floppy: <Floppy />,
  cycle: <Cycle />,
  getNotAutomated: <GetNotAutomated />,
  rebatch: <Rebatch />,
  folder2: <Folder />,
  'download-import': <DownloadImport />,
  'change-claim-message': <ChangeClaimMessage />,
  add: <Add />,
  pen: <Pen />,
  pause: <Pause />,
  'circle-questionMark': <CircleQuestionMark />,
  locker: <Locker />,
  'revert-flux': <RevertFlux />,
  'block-notes': <BlockNotes />,
  '3d-arrow': <ThreeDArrow />,
  'cycle-square-flux': <CycleSquareFlux />,
  'search-void': <SearchVoid />,
  'search-x': <SearchX />,
  'cycle-circle-flux': <CycleCircleFlux />,
  'radio-back': <RadioBack />,
  'radio-pause': <RadioPause />,
  'radio-play': <RadioPlay />,
  'double-check': <DoubleCheck />,
  'user-plus': <UserPlus />,
  'square-plus': <SquarePlus />,
  'pen-squares': <PenSquares />,
  ladder: <Ladder />,
  'attention-signal': <AttentionSignal />,
  'square-link': <SquareLink />,
  splitFix: <SplitFixIcon />,
  connect: <ConnectIcon />,
  disconnect: <DisconnectIcon />,
  isConnecting: <IsConnectingcon />,
  log: <LogIcon />,
  askInfo: <AskInfoIcon />,
  save: <Save />,
  downloadWithArrow: <DowloadWithArrowIcon />,
  uploadWithArrow: <UploadWithArrowIcon />,
  timer: <TimerIcon />,
  reject: <RejectIcon />,
  previous: <PreviousIcon />,
  park: <ParkIcon />,
  table: <TableIcon />,
  layout: <LayoutIcon />,
  hotKeys: <HotkeysIcon />,
  write: <WriteIcon />,
};

export type IconNames = keyof typeof iconMap;
export type IconSize = 'xs' | 'sm' | 'm' | 'l' | 'lg' | 'xl' | '2x' | '3x' | '4x' | '5x' | number | string;

export interface IconProps {
  icon?: IconNames;
  disabled?: boolean;
  cursor?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  label?: string;
  size?: IconSize;
  rotate?: number;
}
const sizeMap: Record<IconSize, string> = {
  xs: '0.75em', // ~12px
  sm: '0.875em', // ~14px
  m: '1em', // ~16px
  l: '1.125em', // ~18px
  lg: '1.25em', // ~20px
  xl: '1.5em', // ~24px
  '2x': '2em', // ~32px
  '3x': '3em', // ~48px
  '4x': '4em', // ~64px
  '5x': '5em', // ~80px
};

const Icon = ({ icon, disabled, onClick, rotate, cursor, style = {}, containerStyle = {}, label, size }: IconProps) => {
  const { theme } = useTheme();
  const getSize = (size?: IconSize): React.CSSProperties => {
    if (!size) return {};
    if (typeof size === 'number' || (typeof size === 'string' && size.endsWith('px'))) {
      return {
        width: size,
        height: size,
      };
    }
    return {
      width: sizeMap[size],
      height: sizeMap[size],
    };
  };

  const getDefaultColor = (): string => {
    switch (icon) {
      case 'priority-high':
      case 'critical-priority':
      case 'warning':
        return theme.colorPalette.red;
      case 'priority-low':
        return theme.colorPalette.turquoise.accent ?? '';
      case 'yellow-square':
      case 'yellow-circle':
        return theme.colorPalette.yellow;
      case 'red-triangle':
      case 'red-circle':
      case 'block-circle':
      case 'already-assigned':
      case 'duplicated-icon':
      case 'exclamation-mark':
        return theme.colorPalette.red;
      case 'green-circle':
        return theme.colorPalette.green;
      case 'priority-medium':
        return theme.colorPalette.yellow;
      case 'paragraph':
      case 'table-not-verified':
      case 'tooltip-filled':
      case 'export-disabled':
        return theme.colorPalette.grey.grey5;
      case 'exclamation-circle':
        return !disabled ? theme.colorPalette.turquoise.accent ?? '' : theme.colorPalette.grey.grey5;
      case 'exportToSapColored':
        return `${theme.colorPalette.grey.grey5},${theme.colorPalette.grey.grey5},${theme.colorPalette.red}`;
      case 'red-alert':
        return theme.colorPalette.iconColors.redAlert;
      case 'less-critical':
        return theme.colorPalette.iconColors.lessCritical;
      case 'green-check':
        return theme.colorPalette.iconColors.greenCheck;
      case 'expired':
        return theme.colorPalette.iconColors.expired;
      case 'critical':
        return theme.colorPalette.iconColors.critical;
      default: {
        if (disabled) return theme.colorPalette.grey.grey5;
        return theme.colorPalette.turquoise.accent ?? '';
      }
    }
  };

  const renderCustomIcon = () => {
    const iconValue = icon ? iconMap[icon] : undefined;

    return iconValue;
  };
  const getRotation = (rotation?: number) => {
    switch (icon) {
      case 'undo-alt': {
        return {
          transform: 'rotateY(180deg)',
        };
      }
      case 'arrow-down-circle':
      case 'angle-down':
      case 'arrow-down':
        return {
          transform: 'rotate(180deg)',
        };
      case 'angle-left': {
        return {
          transform: 'rotate(270deg)',
        };
      }
      default: {
        if (!rotation) return {};
        return {
          transform: `rotate(${rotation}deg)`,
        };
      }
    }
  };

  const combinedStyle = {
    ...style,
    ...getSize(size),
    ...getRotation(rotate),
    color: style.color ?? getDefaultColor(),
  };

  return (
    <IconContainer
      id={`icon-${icon}-${disabled ? 'disabled' : 'enabled'}`}
      data-walkthrough={`icon-${icon}`}
      onClick={onClick}
      disabled={!!disabled}
      cursor={cursor}
      title={label}
      style={{ ...containerStyle, ...getSize(size) }}
    >
      {icon &&
        (() => {
          const rendered = renderCustomIcon();
          if (React.isValidElement(rendered)) {
            return React.cloneElement(rendered as React.ReactElement, {
              color: style.color ?? getDefaultColor(),
              style: combinedStyle,
              size: size,
            });
          }
          if (typeof rendered === 'string') {
            return <img style={{ ...combinedStyle }} alt="custom-icon" src={rendered} />;
          }
          return null;
        })()}
    </IconContainer>
  );
};

export default Icon;
